import type { FC } from 'react';
import { cx } from '@linaria/atomic';
import { Button, PopoverMenu, PopoverMenuItem, usePopoverMenu } from '@frontend/design-system';
import { styles } from '../panel-feature-promotion-banner.styles';
import type {
  PanelFeaturePromotionBannerActionsProps,
  PanelFeaturePromotionBannerDismissMenuProps,
} from '../panel-feature-promotion-banner.types';

export const PanelFeaturePromotionBannerActions: FC<PanelFeaturePromotionBannerActionsProps> = ({
  children,
  dismiss,
  className,
  testId,
}) => {
  if (dismiss) {
    return (
      <div className={cx(styles.actions, className)} data-testid={testId}>
        <div className={styles.actionsPrimaryGroup}>{children}</div>
        <div className={styles.actionsDismissGroup}>{dismiss}</div>
      </div>
    );
  }

  return (
    <div className={cx(styles.actions, className)} data-testid={testId}>
      {children}
    </div>
  );
};

export const PanelFeaturePromotionBannerDismissMenu: FC<PanelFeaturePromotionBannerDismissMenuProps> = ({
  label = 'Maybe Later',
  trackingId,
  placement = 'bottom-end',
  items,
  className,
  testId,
}) => {
  const { getTriggerProps, getMenuProps, getItemProps } = usePopoverMenu({ placement });

  return (
    <>
      <Button
        variant='tertiary'
        {...getTriggerProps()}
        trackingId={trackingId}
        className={cx(styles.dismissButton, className)}
        data-testid={testId}
      >
        {label}
      </Button>

      <PopoverMenu {...getMenuProps()}>
        {items.map((item, index) => (
          <PopoverMenuItem
            key={index}
            {...getItemProps({ index, onClick: item.onClick })}
            trackingId={item.trackingId}
            data-testid={item.testId}
          >
            {item.label}
          </PopoverMenuItem>
        ))}
      </PopoverMenu>
    </>
  );
};
